import React, { useEffect, useRef } from 'react';

const ParallaxBackground = () => {
    const layerBgRef = useRef(null);
    const layerParticlesRef = useRef(null);
    const layerMidRef = useRef(null);
    const layerFgRef = useRef(null);

    useEffect(() => {
        const handleMouseMove = (e) => {
            const x = (window.innerWidth - e.pageX * 2) / 100;
            const y = (window.innerHeight - e.pageY * 2) / 100;

            const layers = [
                { ref: layerBgRef, speed: 2 },
                { ref: layerParticlesRef, speed: 4 },
                { ref: layerMidRef, speed: 6 },
                { ref: layerFgRef, speed: 8 }
            ];

            layers.forEach(({ ref, speed }) => {
                if (ref.current) {
                    const xOffset = x * speed;
                    const yOffset = y * speed;
                    ref.current.style.transform = `translateX(${xOffset}px) translateY(${yOffset}px) scale(1.1)`;
                }
            });
        };

        window.addEventListener('mousemove', handleMouseMove);
        return () => window.removeEventListener('mousemove', handleMouseMove);
    }, []);

    return (
        <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            pointerEvents: 'none', // Allow clicks to pass to Canvas
            zIndex: -1,
            backgroundColor: '#050214' // Deep background color
        }}>
            {/* Layer 1: Main Background (Neon Carnival Texture) */}
            <div ref={layerBgRef} className="layer" style={{
                position: 'absolute',
                top: '-10%', left: '-10%', width: '120%', height: '120%',
                backgroundImage: 'url(/textures/final_dreamland_bg.webp)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                transition: 'transform 0.1s cubic-bezier(0.2, 0.8, 0.2, 1)',
                filter: 'brightness(0.3) contrast(1.2)' // Dimmed to be less overpowering
            }} />

            {/* Layer 2: Glow Orbs (CSS) */}
            <div className="layer" style={{
                position: 'absolute',
                top: '-10%', left: '-10%', width: '120%', height: '120%',
                transition: 'transform 0.1s cubic-bezier(0.2, 0.8, 0.2, 1)'
            }}>
                <div style={{
                    position: 'absolute', top: '25%', left: '25%',
                    width: '16rem', height: '16rem',
                    backgroundColor: 'rgba(59, 130, 246, 0.5)',
                    filter: 'blur(80px)', borderRadius: '50%',
                    mixBlendMode: 'screen'
                }} />
                <div style={{
                    position: 'absolute', top: '50%', right: '25%',
                    width: '24rem', height: '24rem',
                    backgroundColor: 'rgba(168, 85, 247, 0.5)',
                    filter: 'blur(100px)', borderRadius: '50%',
                    mixBlendMode: 'screen'
                }} />
            </div>

            {/* Layer 3: Particles / Stars (CSS Procedural) */}
            <div ref={layerParticlesRef} className="layer" style={{
                position: 'absolute',
                top: '-10%', left: '-10%', width: '120%', height: '120%',
                transition: 'transform 0.1s cubic-bezier(0.2, 0.8, 0.2, 1)',
                opacity: 0.8,
                mixBlendMode: 'screen',
                backgroundImage: `
                    radial-gradient(1px 1px at 10% 10%, white 1px, transparent 0),
                    radial-gradient(1px 1px at 20% 40%, white 1px, transparent 0),
                    radial-gradient(2px 2px at 30% 70%, #00ffff 1px, transparent 0),
                    radial-gradient(2px 2px at 40% 20%, #ff00ff 1px, transparent 0),
                    radial-gradient(1px 1px at 50% 60%, white 1px, transparent 0),
                    radial-gradient(2px 2px at 60% 80%, #ffd700 1px, transparent 0),
                    radial-gradient(1px 1px at 70% 30%, white 1px, transparent 0),
                    radial-gradient(2px 2px at 80% 50%, #00ffff 1px, transparent 0),
                    radial-gradient(1px 1px at 90% 10%, white 1px, transparent 0)
                `,
                backgroundSize: '300px 300px',
                animation: 'twinkle 4s infinite alternate'
            }} />

            <style>
                {`
                @keyframes twinkle {
                    0% { opacity: 0.5; transform: scale(1); }
                    100% { opacity: 1; transform: scale(1.05); }
                }
                `}
            </style>

            {/* Vignette Overlay */}
            <div style={{
                position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
                background: 'radial-gradient(circle at center, transparent 40%, #050214 100%)',
                zIndex: 6,
                pointerEvents: 'none'
            }} />

        </div>
    );
};

export default ParallaxBackground;
